import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Calendar, Users, Target, TrendingUp, BookOpen } from 'lucide-react';
const previews = [{
  icon: FileText,
  title: 'เล่มที่ 1',
  subtitle: 'แผนการสอนพื้นฐานรายสัปดาห์',
  color: 'bg-green-50 border-green-200'
}, {
  icon: Target,
  title: 'เล่มที่ 2',
  subtitle: 'ไดอะแกรมฝึกความคล่องตัว',
  color: 'bg-blue-50 border-blue-200'
}, {
  icon: Users,
  title: 'เล่มที่ 3',
  subtitle: 'แบบฝึกหัดการส่งบอลเป็นทีม',
  color: 'bg-orange-50 border-orange-200'
}, {
  icon: BookOpen,
  title: 'เล่มที่ 4',
  subtitle: 'แผนยุทธวิธีสนาม 11 คน',
  color: 'bg-red-50 border-red-200'
}, {
  icon: TrendingUp,
  title: 'เล่มที่ 5',
  subtitle: 'โปรแกรมฝึกซ้อมเข้มข้น',
  color: 'bg-purple-50 border-purple-200'
}, {
  icon: Calendar,
  title: 'เล่มที่ 6',
  subtitle: 'ปฏิทินฝึกซ้อมรายปี',
  color: 'bg-pink-50 border-pink-200'
}];
export function ContentPreview() {
  return <section className="w-full bg-cream-bg py-20 px-4" data-id="element-58">
      <div className="max-w-7xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-navy-primary mb-4" data-id="element-61">
            ดูตัวอย่างเนื้อหาภายใน
          </h2>
          <p className="text-xl text-gray-700" data-id="element-62">
            ตัวอย่างจริงของหน้าที่คุณจะพบในแต่ละเล่ม: แบบฟอร์มปฏิบัติการ
            เช็กลิสต์ และตารางพร้อมใช้
          </p>
        </motion.div>

        <div className="overflow-x-auto pb-4" data-id="element-63">
          <div className="flex gap-6 min-w-max px-4" data-id="element-64">
            {previews.map((preview, index) => {
            const Icon = preview.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              x: 50
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className={`w-80 ${preview.color} border-2 rounded-xl p-8 shadow-lg flex-shrink-0`} data-id="element-65">
                  <Icon className="w-16 h-16 text-navy-primary mb-4" data-id="element-66" />
                  <h3 className="text-2xl font-display font-bold text-navy-primary mb-2" data-id="element-67">
                    {preview.title}
                  </h3>
                  <p className="text-gray-700 text-lg" data-id="element-68">{preview.subtitle}</p>
                  <div className="mt-6 space-y-2" data-id="element-69">
                    <div className="h-2 bg-gray-300 rounded w-full" data-id="element-70" />
                    <div className="h-2 bg-gray-300 rounded w-4/5" data-id="element-71" />
                    <div className="h-2 bg-gray-300 rounded w-3/4" data-id="element-72" />
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}